import { usePageTitle } from "../hooks/usePageTitle";
import Button from "../components/ui/Button";

// A multi-field contact form was drafted for this page, but there's no backend yet to
// receive submissions - the site already has one form (ResourceHub's) sitting unrouted
// for exactly that reason (see App.jsx). Rather than repeat that, this links straight to
// a real, working mailto instead. Swap in a proper form once there's somewhere for it to
// send to (e.g. reusing the Resend integration server.ts already has for password-reset
// email).
export default function Contact() {
  usePageTitle("Contact");
  return (
    <section style={{ maxWidth: 620, margin: "0 auto", padding: "3.5rem 20px 4rem", textAlign: "center" }}>
      <h1
        style={{
          fontFamily: "var(--font-voice)",
          fontSize: "clamp(26px, 4vw, 34px)",
          color: "var(--navy)",
          margin: "0 0 16px",
        }}
      >
        Get in touch
      </h1>
      <p style={{ fontSize: 15, color: "var(--text-secondary)", lineHeight: 1.7, margin: "0 0 32px" }}>
        Have a question about Groundwork TierUp, need help with your account, or want to talk about how it could fit your team?
        We&rsquo;d love to hear from you.
      </p>

      <div
        className="glass-card"
        style={{ padding: "2rem", textAlign: "left", margin: "0 0 24px" }}
      >
        <p style={{ fontSize: 13, color: "var(--lilac-deep)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 6px" }}>
          General, support &amp; privacy enquiries
        </p>
        <p style={{ fontSize: 20, color: "var(--navy)", fontWeight: 600, margin: "0 0 4px" }}>
          <a href="mailto:hello@groundworktierup.com.au" style={{ color: "var(--navy)" }}>hello@groundworktierup.com.au</a>
        </p>
        <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: 0 }}>
          We aim to reply to support enquiries within 2 business days, and to privacy requests within 5 business days, Australian Central Time (Adelaide).
        </p>
      </div>

      <Button href="mailto:hello@groundworktierup.com.au" size="lg">
        Email us &rarr;
      </Button>

      <div style={{ margin: "40px 0 0" }}>
        <p style={{ fontSize: 13, color: "var(--lilac-deep)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 6px" }}>
          Social media
        </p>
        <p style={{ fontSize: 15, color: "var(--text-secondary)", lineHeight: 1.7, margin: "0 0 16px" }}>
          Follow Groundwork TierUp for updates, practical tips and news.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <Button href="https://www.linkedin.com/company/143082952" external variant="secondary">
            LinkedIn
          </Button>
          <Button href="https://www.facebook.com/people/Groundwork-TierUp/61592099845023/" external variant="secondary">
            Facebook
          </Button>
        </div>
      </div>

      <p style={{ fontSize: 13, color: "var(--text-muted)", margin: "32px 0 0" }}>
        Read our <a href="/privacy" style={{ color: "var(--lilac-deep)", fontWeight: 600 }}>Privacy Policy</a> or{" "}
        <a href="/terms" style={{ color: "var(--lilac-deep)", fontWeight: 600 }}>Terms of Service</a>.
      </p>
    </section>
  );
}
